export const APP_MOUNT_URI = process.env.REACT_APP_MOUNT_URI as string;
const loc = window.location.hostname;
export const API_URI =
  loc === "localhosta"
    ? "http://localhost:3004/"
    : (process.env.REACT_APP_API_URI as string);
